import { Container, Grid, Typography, Divider } from '@mui/material';
import CustomCard from '../common/Card';
import Header from '../common/Header/Header';
import Graph from '../Graph';
import styles from './styles';
import { Card, DashboardProps } from './types';
import Loading from '../common/Loading';

const Dashboard = ({ cards, user, graphData, setOpenProfileDetails, openProfileDetails, loader }: DashboardProps) => {
    return (
        <Container sx={styles.container} maxWidth={false}>
            <Header
                profileImg={user.profileImg}
                name={user.name}
                titleComponent={
                    <>
                        <Typography id="welcome_title" component="div" sx={styles.subTitle} data-testid="title">
                            Welcome,
                        </Typography>
                        <Typography id="dashboard_title" component="div" sx={styles.title}>
                            {user.name}
                        </Typography>
                    </>
                }
                setOpenProfileDetails={setOpenProfileDetails}
                openProfileDetails={openProfileDetails}
            />

            <Divider sx={styles.divider} />
            <Grid container spacing={4}>
                {cards.map((card: Card) => (
                    <Grid item xs={12} sm={6} md={3} key={card.title}>
                        <CustomCard
                            title={card.title}
                            subTitle={card.subTitle}
                            activeCount={card.activeCount}
                            icon={card.icon}
                            width="100%"
                        />
                    </Grid>
                ))}
            </Grid>
            <Typography component="div" sx={{ mt: '24px' }}>
                {graphData.length > 0 ? <Graph data={graphData} /> : null}
            </Typography>
            {loader && <Loading />}
        </Container>
    );
};
export default Dashboard;
